import React from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../components/Navbar';
import VivahLogo from '../components/VivahLogo';

const SERVICES = [
  {
    path: '/consultation',
    grad: 'linear-gradient(145deg, #2A1017 0%, #8E202B 55%, #C59B27 100%)',
    icon: '💍',
    title: 'Vivah Nepal Matrimony',
    manager: 'Managed by Laxmikant Timilsina (9857074103)',
    desc: 'Confidential matchmaking, horoscope/Kundali evaluation, verified member badges, and privacy protection.',
    cta: 'Browse Matrimony Registry →',
    badge: 'Registration QR: 9857074103'
  },
  {
    path: '/catering',
    grad: 'linear-gradient(145deg, #291512 0%, #80301B 55%, #E5A93C 100%)',
    icon: '🍽️',
    title: 'Sabitri Catering Services',
    manager: 'Managed by Krishna Khanal (9867155395)',
    desc: 'Authentic Palpali & Newari bhoj, Royal Indian banquets, buffet spreads, and 5-star hygienic feast management.',
    cta: 'Explore Catering Menus →',
    badge: 'Contact: 9867155395'
  },
  {
    path: '/decor',
    grad: 'linear-gradient(145deg, #1C2321 0%, #2A5235 55%, #D4AF37 100%)',
    icon: '🌺',
    title: 'Sabitri Decor & Tent House',
    manager: 'Jointly Managed by Laxmikant & Krishna',
    desc: 'Royal Palpali floral mandaps, venue lighting, marquee tents, stage backdrops, and complete venue transformation.',
    cta: 'Explore Mandap Catalog →',
    badge: 'Joint Event Management'
  },
];

const LEADERSHIP = [
  {
    icon: '💍',
    title: 'Matrimonial Agency Manager',
    name: 'Laxmikant Timilsina',
    residence: 'Tansen-09, Palpa | Contact: 9857074103',
    role: 'Manages Vivah Nepal Matrimonial Agency & QR Registration. Co-manages Sabitri Decor & Tent House.'
  },
  {
    icon: '🍽️',
    title: 'Catering Services Manager',
    name: 'Krishna Khanal',
    residence: 'Tansen-09, Palpa | Contact: 9867155395',
    role: 'Manages Sabitri Catering Services & Butwal Office. Co-manages Sabitri Decor & Tent House.'
  },
  {
    icon: '💻',
    title: 'Lead Technical Consultant',
    name: 'Prakash Sharma Timilsina',
    residence: 'Portfolio: pourkas.org',
    role: 'Digital Architect leading Python Django backend, React frontend & GCP cloud infrastructure.',
    url: 'https://pourkas.org'
  }
];

export default function Landing() {
  const navigate = useNavigate();

  return (
    <div className="pi">
      <Navbar module={null} />

      {/* Hero Section */}
      <section style={{
        minHeight: 'calc(100vh - 100px)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        padding: 'clamp(2rem, 5vw, 4.5rem) clamp(1rem, 4vw, 2.5rem)',
        background: 'radial-gradient(ellipse 85% 60% at 50% 30%, rgba(197,155,39,0.12) 0%, rgba(158,27,50,0.06) 50%, transparent 85%)'
      }}>
        
        {/* Top Tagline */}
        <div style={{ marginBottom: '1.2rem' }}>
          <span className="ey" style={{
            background: 'linear-gradient(90deg, #AA771C, #9E1B32)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            fontWeight: 700,
            fontSize: 'clamp(0.72rem, 2vw, 0.85rem)',
            letterSpacing: '0.35em'
          }}>
            ✦ JOINTLY OPERATED MARRIAGE & EVENT PLATFORM ✦
          </span>
        </div>

        {/* Logo */}
        <div style={{ marginBottom: '1.5rem' }}>
          <VivahLogo size="large" />
        </div>

        <h1 style={{
          fontFamily: 'var(--serif)',
          fontWeight: 700,
          fontSize: 'clamp(2.2rem, 6vw, 4.4rem)',
          lineHeight: 1.12,
          color: 'var(--deep)',
          maxWidth: '920px',
          marginBottom: '1.2rem'
        }}>
          Uniting Hearts with <em style={{ color: 'var(--rose)', fontStyle: 'italic' }}>Vivah Nepal</em> & Orchestrating Feasts with <em style={{ color: 'var(--gold-d)', fontStyle: 'italic' }}>Sabitri Catering</em>
        </h1>

        <p style={{
          fontSize: 'clamp(0.92rem, 2.5vw, 1.12rem)',
          color: 'var(--muted)',
          maxWidth: '750px',
          lineHeight: 1.75,
          marginBottom: '2.5rem'
        }}>
          A complete joint event platform. Matrimony managed by <strong>Laxmikant Timilsina</strong> (9857074103), Catering managed by <strong>Krishna Khanal</strong> (9867155395), and Decor & Tent House jointly managed. Shared Contact Office: <strong>Yogikuti Chowk, Butwal-10, Lumbini, Nepal</strong>.
        </p>

        {/* Divider */}
        <div className="div" style={{ marginBottom: '3rem' }}>
          <div className="dl" style={{ width: '80px' }} />
          <div className="dg" />
          <div className="dl" style={{ width: '80px' }} />
        </div>

        {/* 3 Core Service Cards */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(310px, 1fr))',
          gap: '1.8rem',
          maxWidth: '1180px',
          width: '100%',
          marginBottom: '3.5rem'
        }}>
          {SERVICES.map((s) => (
            <div
              key={s.path}
              onClick={() => navigate(s.path)}
              style={{
                background: s.grad,
                borderRadius: '24px',
                padding: '2.2rem 1.8rem',
                color: '#fff',
                cursor: 'pointer',
                textAlign: 'left',
                position: 'relative',
                overflow: 'hidden',
                boxShadow: '0 14px 36px rgba(30,23,22,0.18)',
                transition: 'all 0.35s ease',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                minHeight: '340px'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-8px)';
                e.currentTarget.style.boxShadow = '0 24px 50px rgba(30,23,22,0.32)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'none';
                e.currentTarget.style.boxShadow = '0 14px 36px rgba(30,23,22,0.18)';
              }}
            >
              <div>
                <div style={{
                  display: 'inline-block',
                  background: 'rgba(255,255,255,0.18)',
                  backdropFilter: 'blur(8px)',
                  padding: '0.3rem 0.8rem',
                  borderRadius: '100px',
                  fontSize: '0.72rem',
                  letterSpacing: '0.05em',
                  marginBottom: '1rem',
                  fontWeight: 600
                }}>
                  {s.badge}
                </div>
                <div style={{ fontSize: '2.4rem', marginBottom: '0.6rem' }}>{s.icon}</div>
                <h3 style={{ fontFamily: 'var(--serif)', fontSize: '1.8rem', fontWeight: 700, marginBottom: '0.3rem', color: '#fff' }}>
                  {s.title}
                </h3>
                <div style={{ fontSize: '0.78rem', color: '#F7D070', fontWeight: 700, marginBottom: '0.8rem', letterSpacing: '0.03em' }}>
                  {s.manager}
                </div>
                <p style={{ fontSize: '0.86rem', color: 'rgba(255,255,255,0.85)', lineHeight: 1.6, marginBottom: '1.5rem' }}>
                  {s.desc}
                </p>
              </div>

              <div>
                <span className="btn btn-ghost btn-sm" style={{ width: '100%', justifyContent: 'center', fontWeight: 600 }}>
                  {s.cta}
                </span>
              </div>
            </div>
          ))}
        </div>

        {/* Leadership & Technical Board Grid */}
        <div style={{
          width: '100%',
          maxWidth: '1180px',
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
          gap: '1.5rem',
          marginBottom: '3rem'
        }}>
          {LEADERSHIP.map((c, i) => (
            <div key={i} className="card-glass" style={{ textAlign: 'left', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
              <div>
                <div style={{ fontSize: '1.8rem', marginBottom: '0.5rem' }}>{c.icon}</div>
                <div style={{ fontSize: '0.74rem', textTransform: 'uppercase', letterSpacing: '0.12em', color: 'var(--rose)', fontWeight: 700 }}>
                  {c.title}
                </div>
                <h4 style={{ fontFamily: 'var(--serif)', fontSize: '1.45rem', fontWeight: 700, margin: '0.2rem 0 0.4rem', color: 'var(--deep)' }}>
                  {c.name}
                </h4>
                <div style={{ fontSize: '0.84rem', fontWeight: 600, color: 'var(--gold-d)', marginBottom: '0.4rem' }}>
                  📍 {c.residence}
                </div>
                <p style={{ fontSize: '0.8rem', color: 'var(--muted)', lineHeight: 1.55 }}>
                  {c.role}
                </p>
              </div>

              {c.url && (
                <div style={{ marginTop: '0.8rem', borderTop: '1px solid var(--cream-d)', paddingTop: '0.6rem' }}>
                  <a href={c.url} target="_blank" rel="noopener noreferrer" style={{ fontSize: '0.8rem', color: 'var(--rose)', fontWeight: 700, textDecoration: 'underline' }}>
                    Visit Technical Portfolio: pourkas.org →
                  </a>
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Shared Contact Office Banner */}
        <div style={{
          maxWidth: '900px',
          width: '100%',
          background: 'linear-gradient(135deg, #FFF9E6, #FFF0F2)',
          border: '2px dashed var(--gold)',
          borderRadius: '24px',
          padding: '1.8rem 2rem',
          textAlign: 'center',
          boxShadow: '0 8px 30px rgba(197, 155, 39, 0.15)'
        }}>
          <div style={{ fontSize: '0.78rem', letterSpacing: '0.15em', color: 'var(--rose-d)', fontWeight: 700, textTransform: 'uppercase', marginBottom: '0.4rem' }}>
            🏢 Joint Operating Contact Office
          </div>
          <h3 style={{ fontFamily: 'var(--serif)', fontSize: '1.6rem', fontWeight: 700, color: 'var(--deep)', marginBottom: '0.5rem' }}>
            Yogikuti Chowk, Butwal-10, Lumbini, Nepal
          </h3>
          <p style={{ fontSize: '0.88rem', color: 'var(--mid)', lineHeight: 1.6, maxWidth: '720px', margin: '0 auto 1.2rem' }}>
            Visit our shared office for matrimonial consultations with <strong>Laxmikant Timilsina (9857074103)</strong> or catering/decor event bookings with <strong>Krishna Khanal (9867155395)</strong>.
          </p>
          <div style={{ display: 'flex', gap: '0.8rem', justifyContent: 'center', flexWrap: 'wrap' }}>
            <button className="btn btn-rose btn-sm" onClick={() => navigate('/contact')}>
              View Contact Office & Map →
            </button>
            <button className="btn btn-gold btn-sm" onClick={() => navigate('/consultation/payment')}>
              📲 QR Payment to Laxmikant (9857074103)
            </button>
          </div>
        </div>

      </section>
    </div>
  );
}
